import { render, staticRenderFns } from "./ClientTableActions.vue?vue&type=template&id=4224a638&"
import script from "./ClientTableActions.vue?vue&type=script&lang=js&"
export * from "./ClientTableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports